export default function BottomLine({ style }) {
  return (
    <div
      className={`h-0.5 w-3/5 my-2 max-w-sm rounded-md bg-zinc-300 ${style}`}
    ></div>
  );
}
